import axios from "axios";
import {
  convertToCamelCase,
  convertToSnakeCase,
} from "../../redux/actions/helpers";
import Cookies from "js-cookie";
import { dataFormatter } from "../admin";

export const submitQuestion = async (formData) => {
  const response = await axios
    .post(
      "/api/v1/support/submit_question",
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};
